module.exports = __webpack_public_path__ + "a318a045ec1a808767349e44a26051ad.png";